import { render, staticRenderFns } from "./VideoEvaluationClipDetailsForm.vue?vue&type=template&id=b2b75380&scoped=true&"
import script from "./VideoEvaluationClipDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./VideoEvaluationClipDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./VideoEvaluationClipDetailsForm.vue?vue&type=style&index=0&id=b2b75380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b75380",
  null
  
)

export default component.exports